import { backendApi } from "../dynamicBAseQuery";

export const AddAdminApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        AdminCoordinatorSave: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `AdminCoordinatorSave`,
                body: {...args}
            })
        }),

        ViewAdminById:builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `ViewAdminById`,
                body: {...args}
            })
        }),

    })
})
export const {
    useAdminCoordinatorSaveMutation,
    useViewAdminByIdMutation,
}=AddAdminApi;